import { useEffect } from 'react';

/**
 * InstantlyPixel — Leadsy visitor identification tag from Instantly.ai
 *
 * Identifies website visitors who have been sent cold email campaigns,
 * linking email activity (opens/clicks) to site visits for intent signals.
 *
 * Script injected once on mount via DOM to preserve async + data-* attributes.
 * PID sourced from VITE_INSTANTLY_PID env var, with hardcoded fallback.
 *
 * Installed: 2026-04-29
 * Tag ID: vtag-ai-js | Version: 062024
 */
const InstantlyPixel = () => {
    useEffect(() => {
        const SCRIPT_ID = 'vtag-ai-js';
        if (document.getElementById(SCRIPT_ID)) return; // already loaded

        const pid = import.meta.env.VITE_INSTANTLY_PID || '1pG6LOa1ajnAelMCl';

        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.async = true;
        script.src = 'https://r2.leadsy.ai/tag.js';
        script.setAttribute('data-pid', pid);
        script.setAttribute('data-version', '062024');
        document.head.appendChild(script);

        return () => {
            // Script intentionally not removed on unmount — runs once per page load
        };
    }, []);

    return null;
};

export default InstantlyPixel;
